class XAllGuides extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-xall-topic]'));
    this.cards = Array.from(this.querySelectorAll('[data-xall-guide-card]'));
    this.featured = this.querySelector('.xall-guides__featured');
    this.onFilterClick = this.onFilterClick.bind(this);
    this.buttons.forEach((button) => button.addEventListener('click', this.onFilterClick));
  }

  disconnectedCallback() {
    this.buttons.forEach((button) => button.removeEventListener('click', this.onFilterClick));
  }

  onFilterClick(event) {
    const topic = event.currentTarget.dataset.xallTopic || 'all';
    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.xallTopic === topic ? 'true' : 'false');
    });

    this.cards.forEach((card) => {
      const visible = topic === 'all' || card.dataset.topic === topic;
      card.hidden = !visible;
    });

    // Hide the "Featured guide" label + card together when the featured card is
    // filtered out, so the label is never left orphaned above the grid.
    if (this.featured) {
      const featuredCard = this.featured.querySelector('[data-xall-guide-card]');
      this.featured.hidden = featuredCard ? featuredCard.hidden : false;
    }
  }
}

if (!customElements.get('xall-guides')) {
  customElements.define('xall-guides', XAllGuides);
}
